import React from "react";
import newtravel1 from "./images/newtravel1.jpg";
import newtravel2 from "./images/newtravel2.jpg";
import newtravel3 from "./images/newtravel3.jpg";
import newtravel4 from "./images/newtravel4.jpg";


export default function () {
return (
    <div>
    <section id="new-travel" className="mt-5 mx-auto mb-5">
        <div className=" mx-auto row  container  justify-content-center">
        <h2 className="mb-5  d-flex justify-content-start ">
            New Travel Types
        </h2>
        <div className="col-md-3 col-sm-6 mx-lg-0 mx-5 text-center">
        <img src={newtravel1} alt="" />
        <h5 className="fs-3 text-black  ">
            <a href="#" className="text-decoration-none text-black">
                Zip Lines
            </a>
            </h5>
            <p className="">
            Add some adrenalin to your travel senses by zipline travel
            </p>
            <a href="#" className="btn btn-success ">
            Explore
            <i className="fa-solid fa-arrow-right-long mx-2" />
            </a>
        </div>
        <div className="col-md-3 col-sm-6 text-center mx-lg-0 mx-5 disable">
        <img src={newtravel2} alt="" />
        <h5 className="fs-3 text-black ">
            <a href="#" className="text-decoration-none text-black">
                Kayaking
            </a>
            </h5>
            <p className="">
            Add some adrenalin to your travel senses by zipline travel
            </p>
            <a href="#" className="btn btn-success ">
            Explore
            <i className="fa-solid fa-arrow-right-long mx-2" />
            </a>
        </div>
        <div className="col-md-3  text-center disable ipads-disable">
            <img src={newtravel3} alt="" />
            <h5 className="fs-3 text-black">
            <a href="#" className="text-decoration-none text-black">
                Bungee Jump
            </a>
            </h5>
            <p className="">
            Add some adrenalin to your travel senses by zipline travel
            </p>
            <a href="#" className="btn btn-success ">
            Explore
            <i className="fa-solid fa-arrow-right-long mx-2" />
            </a>
        </div>
        <div className="col-md-3 text-center disable ipads-disable">
            <img src={newtravel4} alt="" />
            <h5 className="fs-3 text-black">Canoeing</h5>
            <p className="">
            Add some adrenalin to your travel senses by zipline travel
            </p>
            <a href="#" className="btn btn-success ">
            Explore
            <i className="fa-solid fa-arrow-right-long mx-2" />
            </a>
        </div>
        </div>
    </section>
    </div>
);
}
